<template>
  <div :class="{ collapsed, medical: !isDentalClinic }">
    <TariffEndsHeader/>
    <PasswordExpiresHeader/>
    <OpenedVisitHeaders/>
    <Sidebar/>
    <div class="sidebar-offset" :class="{ collapsed, rightPaneOpened }">
      <AppHeader/>
      <main :class="mainClass">
        <div class="dentist-container">
          <slot/>
        </div>
      </main>
    </div>
    <div class="mobile-shadow" @click="$store.commit('toggleCollapsed')"></div>
    <FormModal v-if="showModal"/>
    <HappyBirthdayModal v-if="rights.includes('birthday')"/>
    <LaravelEcho/>
    <ModuleNotInTariffModal/>
    <JetAPIChatFrame/>
    <GreenAPIChatFrame/>
    <AuraChatFrame/>
    <Popup/>
    <FillDemoAccount/>
    <DiagnocatMultiUploadModal/>
    <ReasonPrompt ref="reasonPrompt"/>
  </div>
</template>

<script>
import Sidebar from "./Sidebar"
import AppHeader from "./AppHeader"
import {mapGetters, mapState} from "vuex"
import FormModal from "@/components/parts/datatable/FormModal"
import HappyBirthdayModal from "@/components/parts/patients/HappyBirthdayModal"
import LaravelEcho from "@/components/parts/general/LaravelEcho"
import ModuleNotInTariffModal from "@/components/parts/billing/ModuleNotInTariffModal"
import TariffEndsHeader from "@/components/parts/general/TariffEndsHeader"
import PasswordExpiresHeader from "@/components/parts/general/PasswordExpiresHeader"
import Popup from "@/components/parts/general/Popup"
import OpenedVisitHeaders from "@/components/parts/patients/visit/OpenedVisitHeaders.vue"
import JetAPIChatFrame from "@/components/parts/crm/JetAPIChatFrame.vue"
import GreenAPIChatFrame from "@/components/parts/crm/GreenAPIChatFrame.vue"
import AuraChatFrame from "@/components/parts/crm/AuraChatFrame.vue"
import FillDemoAccount from "@/components/parts/settings/FillDemoAccount.vue"
import {launchHelpDeskeddy} from "@/services/helpDeskeddy.helper"
import DiagnocatMultiUploadModal from "@/components/parts/patients/DiagnocatMultiUploadModal.vue"
import ReasonPrompt from "@/components/parts/general/ReasonPrompt.vue"
import isDentalClinic from "@/middleware/isDentalClinic"

export default {
  methods: {isDentalClinic},
  components: {
    DiagnocatMultiUploadModal,
    FillDemoAccount,
    JetAPIChatFrame,
    OpenedVisitHeaders,
    GreenAPIChatFrame,
    AuraChatFrame,
    Popup,
    TariffEndsHeader,
    PasswordExpiresHeader,
    ModuleNotInTariffModal,
    LaravelEcho,
    FormModal,
    AppHeader,
    Sidebar,
    HappyBirthdayModal,
    ReasonPrompt
  },
  beforeCreate() {
  },
  data() {
    return {
      experrtoEnabled: false
    }
  },
  provide() {
    return {
      showReasonPrompt: () => this.$refs.reasonPrompt.showPrompt()
    }
  },
  mounted() {
    if(this.user && this.user.id && this.$metrika) {
      let params = { UserID: this.user.id }
      if(this.clinic) params.ClinicID = this.clinic.id
      this.$metrika.userParams(params)
    }

    if(this.clinic && this.clinic.support_button === 1) {
      // (function (w, d, u) {
      //
      //   var s = d.createElement('script');
      //   s.async = true;
      //   s.src = u + '?' + (Date.now() / 60000 | 0);
      //   var h = d.getElementsByTagName('script')[0];
      //   h.parentNode.insertBefore(s, h);
      // })(window, document, 'https://cdn-ru.bitrix24.ru/b15023132/crm/site_button/loader_6_y945vk.js');
      launchHelpDeskeddy()
    }

    if(this.experrtoEnabled && this.user && this.user.role_id == 2) {
      let externalScript = document.createElement('script')
      externalScript.setAttribute('src', 'https://cdn.experrto.io/client/experrto.js')
      document.head.appendChild(externalScript)
      let user = this.user
      externalScript.onload = function() {
        if(window.Experrto) {
          window.Experrto.identify("0092ea9463a637e09cf91be56a88631d0b5dfc6a", {
            userId: user.id
          })
        }
      }
    }

    window.addEventListener('storage', (e) => {
      if (e.key === 'logout') location.href = '/login'
    })

  },
  computed: {
    ...mapState({
      collapsed: state => state.dom.sidebarCollapsed,
      showModal: state => state.datatable.showModal,
      rights: state => state.auth.rights,
      user: state => state.auth.user,
      clinic: state => state.auth.clinic,
      rightPaneOpened: state => state.dom.rightPaneOpened
    }),
    ...mapGetters(['isDentalClinic']),
    mainClass() {
      return `main-${this.$route?.name || ''}`
    }
  },
}
</script>
